import React from "react";
import { injectIntl } from "react-intl";
import Navbar from "website/components/Navbar/Navbar";
import ErrorIcon from "assets/images/ic_Error-Unavailable.svg";
import "./UnavaliablePages.scss";

const UnavaliablePages = injectIntl(({ intl: { messages, locale } }) => {
  return (
    <div>
      <Navbar />
      <section className="unavaliable-page text-center">
        <img className="image" src={ErrorIcon} alt="unavaliable-page" />
        <h2 className="title text-center primary_color bold_font">
          {messages.hideWebsiteTitle}
        </h2>
      </section>
    </div>
  );
});
export default UnavaliablePages;
